export default {
      id: "notifications__complex-logic-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#notifications__complex-logic",
      toString: function () {
        return this.url;
      }
    }